<template>
  <div>
    <v-app-bar dense dark fixed v-if="$vuetify.breakpoint.mobile">
      <v-btn icon @click="$router.go(-1)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>
        {{ !cardDetails ? "Add" : "Update" }} Payment Method
      </v-toolbar-title>
    </v-app-bar>

    <v-container
      class="d-flex align-center"
      :class="{ 'mt-12': $vuetify.breakpoint.mobile }"
    >
      <v-row>
        <v-col>
          <v-card>
            <v-card-text
              v-if="!$vuetify.breakpoint.mobile"
              class="primary white--text text-center"
            >
              <h2>{{ !cardDetails ? "Add" : "Update" }} Payment Method</h2>
            </v-card-text>
            <v-progress-linear v-if="isLoading" indeterminate />
            <v-card-text v-if="cardDetails" class="mb-0">
              <p>
                There is a <strong>{{ cardDetails.card.brand }}</strong> card is
                already added to your account.
                <strong>{{ cardDetails.billing_details.name }}</strong> is the
                owner of this card. Last 4 digits of this card is
                <code>{{ cardDetails.card.last4 }}</code
                >.
              </p>
              <v-alert type="warning" class="mb-0">
                Your current payment method will be replaced
              </v-alert>
            </v-card-text>
            <v-card-text class="pb-0">
              <v-text-field
                outlined
                label="Card Holder Name"
                v-model="name"
                type="text"
              />
              <div class="card-stripe">
                <div ref="cardElement" />
              </div>
              <v-checkbox v-model="check">
                <template v-slot:label>
                  I authorise to save my card information.
                  <!-- <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <a
                        target="_blank"
                        href="http://vuetifyjs.com"
                        @click.stop
                        v-on="on"
                      >
                        Vuetify
                      </a>
                    </template>
                    Opens in new window
                  </v-tooltip>
                  is awesome -->
                </template>
              </v-checkbox>
            </v-card-text>
            <v-card-actions class="pt-0">
              <v-btn
                @click="submit"
                color="primary"
                block
                large
                :disabled="!check || !name"
                :loading="isSubmitting"
                >Add Card</v-btn
              >
            </v-card-actions>
            <v-card-text
              v-if="error || success"
              class="pt-0"
              :class="{ 'danger--text': error, 'primary--text': success }"
            >
              {{ error ? error.message : "The card is added successfully!" }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import Parse from 'parse/lib/browser/Parse'
import { mapActions, mapGetters } from 'vuex'

const PUBLISHABLE_KEY = 'pk_live_51Hca9mL9XL9PNUheZERE3glh8mHxefAHqRy4MOcTQE5irYCbhkOHGXx8Nk7Tcr51dMnS01RUA0JJUDs8UbvYlp0b00SLCtH4Lk'

// const PUBLISHABLE_KEY = 'pk_test_51Hca9mL9XL9PNUhe1FYfznWfUIlyz3IljTmx9etbCin5rUPgvyQLO6QXOyuke5Job8PtBHCZ3y72uULizi2ZNveL00NjBgKKjQ'

const stripe = window.Stripe(PUBLISHABLE_KEY)

export default {
  data () {
    return {
      isLoading: false,
      isSubmitting: false,
      card: null,
      clientSecret: '',
      name: '',
      check: false,
      error: null,
      success: null,
      cardDetails: null
    }
  },
  computed: mapGetters(['user']),
  methods: {
    ...mapActions(['updateUser', 'toggleDialog']),
    stripeElements () {
      var style = {
        base: {
          fontSize: '16px',
          color: '#32325d',
          fontSmoothing: 'antialiased',
          '::placeholder': {
            color: 'rgba(0,0,0,0.4)'
          }
        }
      }
      const elements = stripe.elements()
      this.card = elements.create('card', { style })
      this.card.mount(this.$refs.cardElement)

      // Element focus ring
      // this.card.on("focus", function () {
      //   var el = document.getElementById("card-element");
      //   el.classList.add("focused");
      // });

      // this.card.on("blur", function () {
      //   var el = document.getElementById("card-element");
      //   el.classList.remove("focused");
      // });
    },
    createCustomer () {
      if (
        typeof this.user.get('stripeCustomerId') === 'undefined' ||
        this.user.get('stripeCustomerId') === ''
      ) {
        /** call the cloud fundtion */
        Parse.Cloud.run('createStripeCustomer', {
          email: this.user.get('customEmail')
        }).then(
          (results) => {
            this.updateUser({
              stripeCustomerId: results.id
            })
          },
          (error) => {
            // The object was not retrieved successfully.
            // error is a Parse.Error with an error code and message.
            this.toggleDialog({
              status: true,
              title: 'Error',
              message: error.message
            })
          }
        )
      }
    },
    submit () {
      this.isSubmitting = true
      stripe
        .confirmCardSetup(this.clientSecret, {
          payment_method: {
            card: this.card,
            billing_details: {
              name: this.name
              // email: this.email,
            }
          }
        })
        .then((result) => {
          if (result.error) {
            this.isSubmitting = false
            this.error = result.error
            this.success = null
            this.card.clear()
          } else {
            this.error = null
            this.success = true
            this.orderComplete()
          }
        })
    },

    async orderComplete () {
      await stripe
        .retrieveSetupIntent(this.clientSecret)
        .then(async (result) => {
          const setupIntent = result.setupIntent
          // const setupIntentJson = JSON.stringify(setupIntent, null, 2);
          if (setupIntent.status === 'succeeded') {
            await this.updateUser({
              stripePaymentMethodAdded: true,
              stripePaymentMethodId: setupIntent.payment_method
            })
            // /**We need to attach payment method ID for future use */
            // await stripe.paymentMethods.attach(setupIntent.payment_method, {
            //   customer: this.user.get("stripeCustomerId"),
            // });
            setTimeout(() => {
              /** redirect to payment page */
              this.$router.push('/')
            }, 2500)
          } else {
            this.toggleDialog({
              status: true,
              title: 'Error',
              message: 'Something went wrong, please try again.'
            })
          }
          this.isSubmitting = false
        })
    },
    async tokenCreated () {
      try {
        const result = await Parse.Cloud.run('createCustomerSecret', {
          customerId: this.user.get('stripeCustomerId')
        })
        this.clientSecret = result.client_secret
      } catch (error) {
        this.toggleDialog({
          status: true,
          title: 'Error',
          message: error.message
        })
      }
    }
  },
  async mounted () {
    this.createCustomer()
    this.stripeElements()
    await this.tokenCreated()
    // this.name = this.user.get("firstName") + " " + this.user.get("lastName");
  },
  async created () {
    if (this.user.get('stripePaymentMethodAdded')) {
      this.isLoading = true
      var mData = {
        paymentMethodId: this.user.get('stripePaymentMethodId')
      }
      Parse.Cloud.run('getPaymentMethodDetails', mData)
        .then((results) => {
          this.cardDetails = results
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style lang="scss">
.card-stripe {
  border: 1px solid rgba(black, 0.38);
  padding: 1rem 0.75rem;
  border-radius: 0.24rem;
}
</style>
